import Action from "./class.Action";
import * as Input from "../class.TransporterInput";

/**
 * Creates a bubble with a single button inside.
 */
export default class ButtonPrompt extends Action {
	constructor(options) {
		super(options);
		this.activeBubbleView = null;
		this.isOptional = this.type.is_optional_prompt;
		this.initializeAnalytics();
		this.initialize();
	}

	async initialize() {
		// Create the bubble
		const bubbleView = this.layoutView.placeBubble(
			this.$anchor,
			this.method,
			"student"
		);

		// Create the button
		const button = new Input.Button({
			attributes: {
				inputController: this.inputController,
				className: "btn-like",
				tagName: "a",
				target: this.pointerStr,
			},
		});
		button.$el.addClass("color2");

		// Set the button text
		if (_.isObject(this.model.prompt) && this.model.prompt.html) {
			button.$el.html(
				$(`<div class='inner-content' />`).append(this.model.prompt.html)
			);
		} else {
			button.$el.text(this.model.prompt);
		}

		// Bind the button click.
		button.onClick({
			once: true,
			callback: () => {
				if (this.taItem) {
					this.taItem.setInteracted();
				}
				// Update the bubble text.
				bubbleView.setContent($("<div />").html(button.$el.html()));

				// Run any actions in the "trigger" section for this button.
				this.activeBubbleView = null;
				this.runnerController.createAndTraverseFlow({
					pointer: this.pointer,
					item: this.model,
					flow: [{traverse: "trigger"}],
					onAdvance: ($anchor) => {
						if (!this.isOptional) {
							this.onAdvance($anchor);
						}
					},
					onBypass: () => {
						this.onBypass();
					},
					$anchor: bubbleView.$el,
					context: this.context,
				});
			},
		});

		// Append the bubble, animate if necessary.
		this.activeBubbleView = bubbleView.appendContent(button.$el);
		await this.animationController.FadeIn.start({bubbleView}).scroll();

		// Bind Enter key to Submit click.
		button.$el
			.attr("tabindex", 0)
			.focus(() => {
				button.$el.css("outline", "none");
			})
			.keypress("enter", (event) => {
				if (event.keyCode === 13) {
					button.$el.click();
				}
			})
			.focus();

		// Continue if this is an optional prompt.
		if (this.isOptional) {
			this.onAdvance(bubbleView.$el);
		}
		this.inputController.request({enableAnimations: true});
	}
}
